import React from 'react';
import { Box, Button, Checkbox, FormControlLabel, Typography } from '@mui/material';
import CardLogin from 'app/components/Layouts/CardLogin';
import CircleUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { btnBox, infoText, documentBox, docName, docInfo, checkBoxLabel, styleForm } from './DocSign.sx';
import useDocSign from 'app/pages/Authorization/DocSign/useDocSign';
import DocumentIcon from 'app/components/Icons/DocumentIcon';
import RightArrowIcon from 'app/components/Icons/RightArrowIcon';
import { Documents } from 'app/utils/services/types/documents.type';
import BackButton from 'app/components/BackButton';
import AsanImzaModal from 'app/pages/Authorization/DocSign/AsanImzaModal';

function DocSign() {
  const { t, checked, data, showModal, handleGetDoc, handleCheck, handleSign } = useDocSign();

  return (
    <CardLogin>
      <form style={styleForm}>
        <Box>
          <Typography sx={infoText}>{t('docSign.docSignText')}</Typography>
          {data?.documents.map((item: Documents) => (
            <Box sx={documentBox} key={item.id} onClick={() => handleGetDoc(item.id)}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <DocumentIcon sx={{ mr: '12px' }} />
                <Box>
                  <Typography sx={docName}>{item.title}</Typography>
                  {item.subtitle && <Typography sx={docInfo}>{item.subtitle}</Typography>}
                </Box>
              </Box>
              <RightArrowIcon />
            </Box>
          ))}

          <FormControlLabel
            control={<Checkbox icon={<CircleUnchecked sx={{ fill: '#ccc' }} />} checkedIcon={<CheckCircleIcon />} />}
            label={t('docSign.agreeWithDoc')}
            sx={checkBoxLabel}
            onChange={handleCheck}
          />
        </Box>
        <Box sx={btnBox}>
          <Button type={'button'} variant={'contained'} sx={{ mb: '12px' }} disabled={!checked} onClick={handleSign}>
            {t('docSign.sign')}
          </Button>
          <BackButton text={'docSign.back'} />
        </Box>
      </form>
      {showModal && <AsanImzaModal />}
    </CardLogin>
  );
}

export default DocSign;
